import { FormControl, FormGroup } from '@angular/forms';
import { ParticipantRequest, ParticipantResponse } from '@ent-regis/entregis-ts-angular';

export function buildParticipantForm(p: ParticipantResponse | ParticipantRequest,
                                     registerCompanyId: number,
                                     noneDietaryId?: number
): FormGroup {
  const dietaryRequirementId = (p as ParticipantRequest).dietaryRequirementId
    || ((p as ParticipantResponse).dietary && (p as ParticipantResponse).dietary.dietaryId)
    || noneDietaryId;

  return new FormGroup({
    registerCompanyId: new FormControl(registerCompanyId),
    participantId: new FormControl(p.participantId),
    firstName: new FormControl(p.firstName || ''),
    lastName: new FormControl(p.lastName || ''),
    email: new FormControl(p.email || ''),
    willReceiveEmail: new FormControl(p.willReceiveEmail != null ? p.willReceiveEmail : true),
    mobileNumber: new FormControl(p.mobileNumber || ''),
    jobTitle: new FormControl(p.jobTitle || ''),
    department: new FormControl(p.department || ''),
    isParticipant: new FormControl(p.isParticipant != null ? p.isParticipant : false),
    isAttendee: new FormControl(p.isAttendee != null ? p.isAttendee : false),
    isContact: new FormControl(p.isContact != null ? p.isContact : false),
    dietaryRequirementId: new FormControl(dietaryRequirementId),
    otherDietary: new FormControl(p.otherDietary || ''),
    extNumber: new FormControl(p.extNumber || ''),
  });
}